import { render, staticRenderFns } from "./wxIndex.vue?vue&type=template&id=0b86705b&scoped=true"
import script from "./wxIndex.vue?vue&type=script&lang=js"
export * from "./wxIndex.vue?vue&type=script&lang=js"
import style0 from "./wxIndex.vue?vue&type=style&index=0&id=0b86705b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86705b",
  null
  
)

export default component.exports